// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"532":"ba915cf4b3f50d9bddf3","895":"609b8f5c65695856e6de"}[chunkId] + ".js";
};